import { supabase } from '../../supabaseClient';

const comms = supabase.schema('comms');

export async function requireSession() {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Not authenticated');
  return session;
}

export async function commsInsert(table, row) {
  await requireSession();
  const { data, error } = await comms.from(table).insert(row).select().single();
  if (error) throw error;
  return data;
}

export async function commsUpdate(table, idField, id, changes) {
  await requireSession();
  const { data, error } = await comms.from(table).update(changes).eq(idField, id).select().single();
  if (error) throw error;
  return data;
}

export async function commsUpsert(table, row, onConflict) {
  await requireSession();
  const { data, error } = await comms.from(table).upsert(row, { onConflict }).select().single();
  if (error) throw error;
  return data;
}

export async function commsDelete(table, idField, id) {
  await requireSession();
  const { error } = await comms.from(table).delete().eq(idField, id);
  if (error) throw error;
}

export async function commsUpsertSetting(table, key, value) {
  await requireSession();
  const { error } = await comms.from(table).upsert({ key, value, updated_at: new Date().toISOString() });
  if (error) throw error;
}

export async function commsUpload(file, path) {
  await requireSession();
  const { data, error } = await supabase.storage.from('comms-assets').upload(path, file, { upsert: true });
  if (error) throw error;
  const { data: { publicUrl } } = supabase.storage.from('comms-assets').getPublicUrl(data.path);
  return publicUrl;
}
